import api from 'Application/api/api';

const getFilterRange = async signal => {
	const response = await api.get('/clients/filters-range', {
		signal,
	});

	return {
		...response,
	};
};

export default getFilterRange;
